import { render, staticRenderFns } from "./stockControl.vue?vue&type=template&id=2a9c872a&scoped=true&"
import script from "./stockControl.vue?vue&type=script&lang=js&"
export * from "./stockControl.vue?vue&type=script&lang=js&"
import style0 from "./stockControl.vue?vue&type=style&index=0&id=2a9c872a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c872a",
  null
  
)

export default component.exports